(function() { window.GUID_4d46f722_97a4_4855_b88f_6af7bfec8c7a = { getGuid: function() { return "4d46f722-97a4-4855-b88f-6af7bfec8c7a"; } }; })();
var Scores;
(function (Scores) {
    CS.FormReady(function (formId) {
        var actualForm = this;
        if (formId == "ScorePopup") {
            var InputPatchFocus = $('#InputPatchFocus');
            var popup = $('#ScoreSheetContainer');
            ChangeColorOfUsedPlayers(0, popup);
            ChangeColorOfUsedPlayers(1, popup);
            var BottomOfScoreSheetOptions = $('#BottomOfScoreSheetOptions');
            var moreDatasVisibility = $('#MoreDatasVisibility');
            if (moreDatasVisibility.val() == "True") {
                ShowHideMoreDatas(popup, moreDatasVisibility);
            }
            var EncounterTypesDropDown = $('#EncounterTypes');
            if (EncounterTypesDropDown != null && EncounterTypesDropDown.length > 0) {
                EncounterTypesDropDown.on('change', function () {
                    var form = popup.parent();
                    var container = form.parent();
                    var data = {
                        encounterRowId: $('#encounterRowId').val(),
                        newFormat: $(this).val()
                    };
                    CompuSport.Ajax.Post(CSParameters.RUrl + 'Scores/ChangeScoreSheetFormat/' + CSParameters.SportEventId, data, function (response) {
                        $(container).empty().append(response);
                        CS.RefreshBehaviorOfScript(form);
                    });
                });
            }
            var $this = $(this);
            var autoOpponentScore = $this.data('autoopponentscore');
            //validateopponentscore en realité valide le max score et l'opp score.
            var validateScore = $this.data('validateopponentscore') == "True";
            var nbrPtsMax = $this.data('nbrptsmax');
            var autoselectentity = $this.data('autoselectentity');
            var inputBoxes = $('.ScoreBox input', popup);
            inputBoxes.on('focus', function (e) {
                var element = $(this);
                var oppElement = GetScoreOpponentOfGame(element, popup);
                oppElement.addClass('IsHighlighted');
            }).on('blur', function (e) {
                var element = $(this);
                var oppElement = GetScoreOpponentOfGame(element, popup);
                AutoSetOppScore(element, oppElement, autoOpponentScore, validateScore);
                if (validateScore) {
                    ValidateMaxScore(element, nbrPtsMax);
                }
                oppElement.removeClass('IsHighlighted');
            }).on('keydown', function (e) {
                var key = window.event ? e.keyCode : e.which;
                if (key == 13) {
                    $(this).trigger('blur');
                }
            }).on('keyup', function (e) {
                //Si c'est la touche TAB, je sors
                if (e.keyCode == 9) {
                    return;
                }
                var element = $(this);
                var oppElement = GetScoreOpponentOfGame(element, popup);
                AutoSetOppScore(element, oppElement, autoOpponentScore, validateScore);
                if (validateScore) {
                    ValidateMaxScore(element, nbrPtsMax);
                }
            });
            /*Checkboxes des winners*/
            var winnerBox = $('.WinnerBox.Editable', popup);
            winnerBox.on('click', function (e) {
                var element = $(this);
                var elementOpp = null;
                if (winnerBox[0] == element[0]) {
                    elementOpp = winnerBox[1];
                }
                else {
                    elementOpp = winnerBox[0];
                }
                var isWinnerhidden = $('input', $(this));
                if (isWinnerhidden.val() == "True") {
                    isWinnerhidden.val("False");
                    $('.WinnerBoxContainer', element).removeClass('IsWinner');
                }
                else {
                    isWinnerhidden.val("True");
                    $('.WinnerBoxContainer', element).addClass('IsWinner');
                }
                if ($('.IsWinner', winnerBox).length > 0) {
                    $('#EncounterState', BottomOfScoreSheetOptions).val('1');
                }
                else {
                    $('#EncounterState', BottomOfScoreSheetOptions).val('0');
                }
            });
            /*Partie pour le dropdown Ero, Eight on break, etc*/
            var ScoreEroEightOnBreakBoxes = $('.EroEightTR.Editable', popup);
            var EroEightOnBreakSelector = null;
            ScoreEroEightOnBreakBoxes.on('mousedown', function (e) {
                if (EroEightOnBreakSelector != null) {
                    EroEightOnBreakSelector.slideUp(150);
                }
                var ScoreEroEightOnBreak = $(this);
                var pop = $('<div>');
                var html = "";
                if ($(this).hasClass('Nine')) {
                    html += "<div class='EroEightOnBreakSelector'>";
                    html += "<div class='ErorEightOnBreakBtn Ero' data-val='E'><span class='Ero'>E</span></div>";
                    html += "<div class='ErorEightOnBreakBtn Eight' data-val='8'><span class='Eight'>9</span></div>";
                    html += "<div class='ErorEightOnBreakBtn Both' data-val='E8'><span class='Ero'>E</span><span class='Eight'>9</span></div>";
                    html += "<div class='ErorEightOnBreakBtn TableRun' data-val='TR'><span class='TableRun'>TR</span></div>";
                    html += "<div class='ErorEightOnBreakBtn Blank' data-val='Blank'><span></span></div>";
                    html += "</div>";
                }
                else {
                    html += "<div class='EroEightOnBreakSelector'>";
                    html += "<div class='ErorEightOnBreakBtn Ero' data-val='E'><span class='Ero'>E</span></div>";
                    html += "<div class='ErorEightOnBreakBtn Eight' data-val='8'><span class='Eight'>8</span></div>";
                    html += "<div class='ErorEightOnBreakBtn Both' data-val='E8'><span class='Ero'>E</span><span class='Eight'>8</span></div>";
                    html += "<div class='ErorEightOnBreakBtn TableRun' data-val='TR'><span class='TableRun'>TR</span></div>";
                    html += "<div class='ErorEightOnBreakBtn Blank' data-val='Blank'><span></span></div>";
                    html += "</div>";
                }
                pop.append(html);
                pop.appendTo(ScoreEroEightOnBreak);
                EroEightOnBreakSelector = $('.EroEightOnBreakSelector', ScoreEroEightOnBreak);
                var buttons = $('.ErorEightOnBreakBtn', EroEightOnBreakSelector);
                buttons.on('mousedown', function (e) {
                    var element = $(this);
                    var value = element.data('val');
                    $('.EroEightTRContent', ScoreEroEightOnBreak).html(element.html());
                    var eroHidden = $('[id^="Ero_"]', ScoreEroEightOnBreak);
                    var eightHidden = $('[id^="Eight_"]', ScoreEroEightOnBreak);
                    var trHidden = $('[id^="TR_"]', ScoreEroEightOnBreak);
                    if (value == "E") {
                        eroHidden.val(1);
                        eightHidden.val(0);
                        trHidden.val(0);
                    }
                    else if (value == "8") {
                        eightHidden.val(1);
                        eroHidden.val(0);
                        trHidden.val(0);
                    }
                    else if (value == "E8") {
                        eroHidden.val(1);
                        eightHidden.val(1);
                        trHidden.val(0);
                    }
                    else if (value == "TR8") {
                        eroHidden.val(0);
                        eightHidden.val(1);
                        trHidden.val(1);
                    }
                    else if (value == "TR") {
                        trHidden.val(1);
                        eroHidden.val(0);
                        eightHidden.val(0);
                    }
                    else {
                        eroHidden.val(0);
                        eightHidden.val(0);
                        trHidden.val(0);
                    }
                    EroEightOnBreakSelector.slideUp(150);
                    e.stopPropagation();
                    e.preventDefault();
                });
                EroEightOnBreakSelector.slideDown(150);
                e.stopPropagation();
                e.preventDefault();
            });
            //$('.AddSubstitut', popup).on('click', function (e) {
            //    e.preventDefault();
            //    var form = popup.parent();
            //    var container = form.parent();
            //    var jsonData = form.serialize();
            //    var url = $(this)[0].href;
            //    $.ajax({
            //        type: "POST",
            //        async: true,
            //        cache: false,
            //        url: url,
            //        data: jsonData,
            //        success: function (response) {
            //            $(container).empty().append(response);
            //            RefreshBehaviorOfScript(form);
            //        }
            //    });
            //});
            $('.Calculate').on('click', function (e) {
                e.preventDefault();
                var form = popup.parent();
                var container = form.parent();
                PostForm(container, 'EnterKey');
            });
            var OptionsSelector = null;
            $('.MenuOptions', BottomOfScoreSheetOptions).on('click', function (e) {
                OptionsSelector = $('.OptionsSelector', BottomOfScoreSheetOptions);
                OptionsSelector.slideDown(150);
                e.stopPropagation();
                e.preventDefault();
            });
            var optionMenus = $('.OptionMenu', BottomOfScoreSheetOptions);
            optionMenus.on('mousedown', function (e) {
                e.stopPropagation();
                e.preventDefault();
                var form = popup.parent();
                var container = form.parent();
                var actualMenu = $(this);
                if (actualMenu[0].id == "MoreDatasMenu") {
                    ShowHideMoreDatas(popup, moreDatasVisibility, true);
                }
                else if (actualMenu[0].id == "UpdateHDCPFromAvg") {
                    PostForm(container, 'UpdateHDCPFromAvg');
                }
                else if (actualMenu[0].id == "AddSubstitut_0") {
                    PostForm(container, 'AddSubstitut_0');
                }
                else if (actualMenu[0].id == "AddSubstitut_1") {
                    PostForm(container, 'AddSubstitut_1');
                }
                else {
                    var elementToRefresh = $(this).parent().data('elementtorefresh');
                    var data = {
                        encounterRowId: $('#encounterRowId').val(),
                        elementToRefresh: elementToRefresh
                    };
                    var url = "";
                    if (actualMenu[0].id == "DeleteUnusedSubstitutes") {
                        url = CSParameters.RUrl + "Scores/DeleteUnusedSubstitutes/" + CSParameters.SportEventId;
                    }
                    else if (actualMenu[0].id == "ClearScoreSheet") {
                        url = CSParameters.RUrl + "Scores/ClearScoreSheet/" + CSParameters.SportEventId;
                    }
                    else if (actualMenu[0].id == "SwitchOpponentOfEncounter") {
                        url = CSParameters.RUrl + "Scores/SwitchOpponentOfEncounter/" + CSParameters.SportEventId;
                    }
                    var answer = false;
                    answer = confirm(OptionsSelector.data('areyousuremessage'));
                    if (answer && url != "") {
                        CompuSport.Ajax.Post(url, data, function (response) {
                            $(container).empty().append(response);
                            CS.RefreshBehaviorOfScript(form);
                        });
                    }
                }
                if (OptionsSelector != null) {
                    OptionsSelector.slideUp(150);
                }
            });
            CS.doc.on('mousedown.ScoreSheetSelectors', function (e) {
                if (EroEightOnBreakSelector != null) {
                    EroEightOnBreakSelector.slideUp(150);
                }
                if (OptionsSelector != null) {
                    OptionsSelector.slideUp(150);
                }
            });
            var entitiesDropDown = $('select', popup);
            entitiesDropDown.on('change', function (e) {
                var me = $(this);
                var newValue = me.val();
                var selectedName = $('option:selected', this).text();
                var id = $(this)[0].id;
                var splitted = id.split('_');
                var encounterRowId = $('#encounterRowId').val();
                var parentPositionOrder = splitted[1];
                if (newValue == "AddRemovePlayers") {
                    let otherSamePosOrder = $('.PlayerNameDropDown [id^="EntityId_' + parentPositionOrder + '_"]', popup);
                    var entityId = $(this).parents('.PlayerNameDropDown').data('parentid');
                    $(this).val("0");
                    //(getActionUrl, source, onPostCompleted, onClose, FullScreen, modal, test)
                    var data = {
                        SelectedTeamId: entityId,
                        sourceOfUpdate: 'ScoreSheet',
                        encounterRowId: encounterRowId
                    };
                    let mypopup = new CompuSport.Controls.Popup();
                    mypopup.GetAndShow({
                        PopupId: "AddMembers",
                        Url: CSParameters.RUrl + 'Teams/AddGridViewMemberOfTeams/' + CSParameters.SportEventId,
                        Data: data,
                        AjaxCallType: CompuSport.Ajax.AjaxCallType.GET
                    });
                    mypopup.OnPosted = function (response) {
                        if (response.ForceRefreshOfDropDown != null && response.ForceRefreshOfDropDown == true) {
                            var dropDowns = this.Source;
                            $.each(dropDowns, function () {
                                var dropDown = $(this);
                                var keepLastValue = dropDown.val();
                                dropDown.empty();
                                $.each(response.dropdownitems, function (index, element) {
                                    var newOption = $('<option/>', { value: element.Value }).html(element.Text);
                                    if (element.TextColor != null) {
                                        newOption.css('color', element.TextColor);
                                    }
                                    dropDown.append(newOption);
                                });
                                dropDown.val(keepLastValue);
                            });
                            ChangeColorOfUsedPlayers(0, popup);
                            ChangeColorOfUsedPlayers(1, popup);
                        }
                    };
                    /*
                    ShowFormPopup(CSParameters.RUrl + 'Teams/AddGridViewMemberOfTeams/' + CSParameters.SportEventId, data, otherSamePosOrder, function (response) {

                        if (response.ForceRefreshOfDropDown != null && response.ForceRefreshOfDropDown == true) {
                            var dropDowns = this.Source;

                            $.each(dropDowns, function () {
                                var dropDown = $(this);
                                var keepLastValue = dropDown.val();
                                dropDown.empty();

                                $.each(response.dropdownitems, function (index, element) {
                                    var newOption = $('<option/>', { value: element.Value }).html(element.Text);
                                    if (element.TextColor != null) {
                                        newOption.css('color', element.TextColor);
                                    }
                                    dropDown.append(newOption);
                                });

                                dropDown.val(keepLastValue);
                            });
                            this.dialog('close');
                            ChangeColorOfUsedPlayers(0, popup);
                            ChangeColorOfUsedPlayers(1, popup);
                        }
                    }, null, false, false, 'AddMembers');
                    */
                }
                else {
                    if (autoselectentity == "True") {
                        let otherSamePosOrder = $('[id^="EntityId_' + parentPositionOrder + '_' + splitted[2] + '_"]', popup);
                        var startSelectName = false;
                        $.each(otherSamePosOrder, function (index, element) {
                            if (element.id == me[0].id) {
                                startSelectName = true;
                            }
                            else if (element.tagName == "SELECT") {
                                startSelectName = false;
                            }
                            else if (startSelectName) {
                                $(this).html(selectedName);
                            }
                        });
                    }
                    ChangeColorOfUsedPlayers(parentPositionOrder, popup);
                }
            });
            var divPlayerNames = $('div.PlayerName.Editable', popup);
            divPlayerNames.on('click', function (e) {
                var id = $(this)[0].id;
                var splitted = id.split('_');
                var parentPositionOrder = splitted[1];
                let otherSamePosOrder = $('.PlayerNameDropDown [id^="EntityId_' + parentPositionOrder + '_"]', popup);
                var cloneDropDown = otherSamePosOrder.first().clone(false);
                cloneDropDown[0].name = $(this)[0].id;
                $(this).html(cloneDropDown);
                $(this).off('click');
            });
        }
    });
    function ChangeColorOfUsedPlayers(parentPositionOrder, popup) {
        var selectedPlayers = $('[id^="EntityId_' + parentPositionOrder + '_"] option:selected', popup);
        let otherSamePosOrder = $('[id^="EntityId_' + parentPositionOrder + '_"] option[value!="AddRemovePlayers"]', popup);
        otherSamePosOrder.css('color', 'yellow');
        $.each(selectedPlayers, function () {
            var optionSelected = $(this);
            $.each(otherSamePosOrder, function () {
                var otherOption = $(this);
                var otherOptionVal = otherOption.val();
                if (optionSelected.text() == otherOption.text() && otherOptionVal != "0") {
                    otherOption.css('color', '#888');
                }
            });
        });
    }
    //##############################################################################
    //################### Ici, j'obtiens la boites de adverse en fonction ##########
    //################### de la boite que je passe #################################
    //##############################################################################
    function GetScoreOpponentOfGame(element, popup) {
        var oppboxnumber = element.data('oppboxnumber');
        var splitted = element[0].id.split('_');
        //var opponentBox = $('#Score_' + oppboxnumber, popup);
        var opponentBox = $('#' + splitted[0] + '_' + oppboxnumber, popup);
        return opponentBox;
    }
    function AutoSetOppScore(element, oppElement, autoOpponentScore, validateScore) {
        element.removeClass('IsInError');
        oppElement.removeClass('IsInError');
        var val = parseFloat(element.val());
        var oppVal = parseFloat(oppElement.val());
        if (!isNaN(val) && val != autoOpponentScore) {
            if (isNaN(oppVal)) {
                oppElement.val(autoOpponentScore);
            }
            else if (val == autoOpponentScore && oppVal == autoOpponentScore) {
                oppElement.val("");
            }
            else if (val != autoOpponentScore && oppVal != autoOpponentScore && autoOpponentScore != "" && validateScore) {
                element.addClass('IsInError');
                oppElement.addClass('IsInError');
            }
        }
        else {
            if (!isNaN(oppVal) && oppVal == autoOpponentScore) {
                oppElement.val("");
            }
        }
    }
    function ValidateMaxScore(element, maxScore) {
        var val = parseFloat(element.val());
        if (!isNaN(val) && val > maxScore) {
            element.addClass('IsInError');
        }
    }
    function ShowHideMoreDatas(popup, moreDatasVisibility, fromClick) {
        var moreDatas = $('.MoreDatas', popup);
        var moreDatasHeader = $('.MoreDatasHeader', popup);
        if (moreDatas.length > 0) {
            var moreDatasWidth = moreDatas.width() * 2 + 10;
            var popupWidth = popup.width();
            if (moreDatas.is(':visible')) {
                popup.width(popupWidth - moreDatasWidth);
                moreDatas.hide();
                moreDatasHeader.hide();
                moreDatasVisibility.val(false);
            }
            else {
                popup.width(popupWidth + moreDatasWidth);
                moreDatas.show();
                moreDatasHeader.show();
                moreDatasVisibility.val(true);
            }
            if (fromClick) {
                var data = { keyName: 'MoreDatasVisibility', value: moreDatasVisibility.val() };
                CompuSport.Ajax.Post(CSParameters.RUrl + 'Scores/SaveUserData/' + CSParameters.SportEventId, data, function (response) { });
            }
        }
    }
    function UpdateHDCPFromAvg(popup) {
        var data = {
            encounterRowId: $('#encounterRowId').val()
        };
        CompuSport.Ajax.Post(CSParameters.RUrl + 'Scores/UpdateHDCPFromAvg/' + CSParameters.SportEventId, data, function (response) {
            var customStats = $('.TxtCustomStat');
            var list = response;
            var end = list.length;
            $.each(customStats, function () {
                var customStat = $(this);
                var selectedEntityId = $('#' + this.name.replace("CustomStat", "EntityId")).val();
                for (var i = 0; i < end; i++) {
                    var HDCPAverage = list[i];
                    if (HDCPAverage.EntityBaseId == selectedEntityId) {
                        customStat.val(HDCPAverage.CustomStat);
                        break;
                    }
                }
            });
        });
    }
    //function UpdateHDCPPerRound() {
    //    SumAvgBalance
    //    NegativSumAvg
    //    HDCPChart
    //}
})(Scores || (Scores = {}));

//# sourceMappingURL=Scores.js.map
